import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from './detailsBox.module.scss';
import policeManIcon from '../../../assets/Imagess/policeMan.svg';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import ApplicantsTab from '../../Atoms/Tabs/InfoTab';
import emailIcon from '../../../assets/Imagess/GreenEmail.svg';
import phoneIcon from '../../../assets/Imagess/GreenPhone.svg';
import FormIcon from '../../../assets/Imagess/FormIcon.svg';
import InfoCard from '../../Atoms/Cards/InfoCard';
import ExportIcon from '../../../assets/Imagess/exportIcon.svg';
import PrintIcon from '../../../assets/Imagess/printIcon.svg';
import MoreButton from '../../Molecules/Custom/MoreButton';
import ReactToPrint from 'react-to-print';
import { isEmpty } from 'lodash';
import ReseachFile from '../../Atoms/Cards/ResearchFile';
import AttachmentsIcon from '../../../assets/Imagess/AttachmentsIcon.svg';
const degreeTypeAr = (type) => {
  const t = String(type ?? '')
    .trim()
    .toLowerCase();

  if (t === 'undergraduate' || t === 'ug' || t.includes('under'))
    return 'بكالوريوس';
  if (t === 'graduate' || t === 'master' || t.includes('grad'))
    return 'ماجستير';
  if (
    t === 'phd' ||
    t === 'doctorate' ||
    t.includes('phd') ||
    t.includes('doctor')
  )
    return 'دكتوراه';

  return type ?? '-'; // fallback if backend sends something else
};
function DetailsBox({ data, mode, setDetails, setMoveRight }) {
  const [info, setInfo] = useState(null);
  const [selected, setSelected] = useState('onlineForm');
  const componentRef = useRef(null);

  const tabs = useMemo(
    () => [
      {
        index: 0,
        name: 'onlineForm',
        text: 'نموذج عبر الإنترنت',
        icon: FormIcon,
      },
      {
        index: 1,
        name: 'attachments',
        text: 'الوثائق',
        icon: AttachmentsIcon,
      },
    ],
    []
  );

  const attachments = useMemo(() => {
    if (isEmpty(data)) return [];

    const list = [
      {
        id: 'academicQualtificationContent',
        type: 'المؤهل الأكاديمي',
        fileName: data.academicQualtificationFileName,
        base64String: data.academicQualtificationContent,
        mimeType: data.academicQualtificationContentType,
      },
      {
        id: 'financialCertificate',
        type: 'الشهادة المالية',
        fileName: data.financialCertificateFileName,
        base64String: data.financialCertificate,
        mimeType: data.financialCertificateContentType,
      },
      {
        id: 'peopleDeterminationCard',
        type: 'بطاقة أصحاب الهمم',
        fileName: data.peopleDeterminationCardFileName,
        base64String: data.peopleDeterminationCard,
        mimeType: data.peopleDeterminationCardContentType,
      },
      {
        id: 'salaryCertificate',
        type: 'شهادة الراتب',
        fileName: data?.salaryCertificateFileName,
        base64String: data?.salaryCertificate,
        mimeType: data?.salaryCertificateContentType,
      },
    ];

    return list.filter((x) => !!x?.base64String);
  }, [data]);

  useEffect(() => {
    if (!isEmpty(data)) {
      const personalInfo = [
        {
          الاسم_الأول: data?.firstName,
          الاسم_الثاني: data?.middleName || '',
          الاسم_الأخير: data.lastName,
          البريد_الإلكتروني: data.email,
          رقم_الهاتف: data.phoneNumber,
        },
      ];
      const fullName = [data?.firstName, data?.middleName, data?.lastName]
        .filter(Boolean)
        .join(' ');
      setInfo({
        fullName: fullName,
        email: data?.email,
        phone: data?.phoneNumber,
        program: data?.degreeName_AR,
        degreeType: data?.degreeType,
        description: data?.description,
        personalInfo,
      });
    }
  }, [data]);

  return (
    <>
      <div
        className={styles.parentContainer}
        id='PrintDetails'
        ref={componentRef}
      >
        <div className={styles['major-box']}>
          <div className={styles['box-side']}>
            <img src={policeManIcon} className={styles.leftImg} alt='' />
          </div>

          <div className={styles['box-body']}>
            <h3>{info?.fullName}</h3>
            {info?.email && (
              <span className={styles.spanCont}>
                <img src={emailIcon} alt='' />
                {info.email}
              </span>
            )}
            {info?.phone && (
              <span className={styles.spanCont}>
                <img src={phoneIcon} alt='' />
                {info.phone}
              </span>
            )}
            <hr />
            <h4>
              نوع البرنامج : <span>{degreeTypeAr(info?.degreeType)}</span>
            </h4>
            <h4>
              البرنامج :<span> {info?.program}</span>
            </h4>
          </div>
        </div>

        <div
          className={`${styles['tab-select-container']} ${styles.row}`}
          style={{ marginTop: 25, marginBottom: 15 }}
        >
          <div className={`${styles['tab-container']} ${styles['w-90']}`}>
            {tabs.map((tab) => (
              <ApplicantsTab
                key={tab.index}
                text={tab.text}
                icon={tab.icon}
                handleOnClick={() => setSelected(tab.name)}
                active={tab.name === selected}
                shadowed={false}
              />
            ))}
          </div>

          <div
            style={{ position: 'absolute', right: 40, marginTop: 25 }}
            className={styles['no-print']}
          >
            <MoreButton icon={moreInfo} top={1} right={30}>
              <div className={styles['in-container']}>
                <ReactToPrint
                  trigger={() => (
                    <div>
                      <img src={PrintIcon} alt='تفاصيل' />
                      <span>طباعة</span>
                    </div>
                  )}
                  content={() => componentRef.current}
                />
              </div>
            </MoreButton>
          </div>
        </div>

        {selected === 'onlineForm' && (
          <div className={styles.row}>
            <InfoCard
              title='المعلومات الشخصية'
              values={info?.personalInfo}
              width='w-49'
              column={1}
            />
            <InfoCard title='الوصف' width='w-49' text={info?.description} />
          </div>
        )}

        {selected === 'attachments' && (
          <div className={styles.row} style={{ display: 'flex', gap: 32 }}>
            {attachments.length === 0 ? (
              <div style={{ padding: 12 }}>لا يوجد مرفقات</div>
            ) : (
              attachments.map((f) => (
                <ReseachFile
                  key={f.id}
                  id={f.id}
                  type={f.type}
                  fileName={f.fileName}
                  base64String={f.base64String}
                  mimeType={f.mimeType}
                />
              ))
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default DetailsBox;
